import { AdminMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenuPopout/AdminMenuPopout";

export { AdminMenuPopout };
